import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from './actions';
import * as routes from '../../../routes/const';

import SummaryPage from '../components/summary/SummaryPage';

import SummaryConfirm from './components/SummaryConfirm';

import {getQuoteCreateFromattedSummary} from './selector';

//import {notify} from '../../../components/libs/notification';

/**
 * QuoteSummary
 *
 * quote summary is the container for the final view in the Corporate Quote
 * creation flow. It requests data from the quoteSummary api endpoint to
 * populate the various presentational components.
 */
class QuoteSummary extends Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      showConfirm: false
    };
  }

  /**
   * componentWillMount
   * if there is no quoteId in redux, bounce the user out to the start of there
   * quote process.
   * otherwise we fetch the summary using the stored quoteId
   */
  componentWillMount() {
    const {router} = this.context;
    const {quoteId} = this.props;
    const {updateStep, fetchQuoteSummary} = this.props.actions;

    updateStep(0);

    /** NOTE: Commented on 4th Sep 2017 after confirming with Felix. 
    The quote drafts are not currently available.So, the message is misleading - Mythreyi**/
   /** notify({
      title: `Quote Ref. ${quoteId} saved as draft`,
      message: 'You can choose to come back and submit this quote order at a later time.'
    });
  **/
    if (!quoteId) router.push(routes.CQ_CREATE_QUESTIONS);
    else fetchQuoteSummary(quoteId);
  }

  /**
   * componentWillUpdate
   * if the user has just completed a successfull submission, push them to
   * the submitted route
   */
  componentWillUpdate(nextProps) {
    const {router} = this.context;

    if (nextProps.hasSubmitted) router.push(routes.CQ_CREATE_SUBMITTED);
  }

  /**
   * handleOptionsEdit
   * handleLeaseEdit
   * handleDeliveryEdit
   * handleVehicleChange
   *
   * these are all callbacks passed down to display components
   * which will redirect the user to the relevant section for editing
   */
  redirectTo = (route) => {
    this.context.router.push(route);
  }

  handleOptionsEdit = () => {
    this.redirectTo(routes.CQ_CREATE_OPTIONS);
  }

  handleLeaseEdit = () => {
    this.redirectTo(routes.CQ_CREATE_LEASE);
  }

  handleDeliveryEdit = () => {
    this.redirectTo(routes.CQ_CREATE_DELIVERY);
  }

  handleVehicleChange = () => {
    this.redirectTo(routes.CQ_CREATE_VEHICLE);
  }

  /**
   * toggleConfirm
   * when the user wants to change vehicles, we need to warn them it will
   * start a new quote, so show them a confirm dialog
   */
  toggleConfirm = () => {
    const showConfirm = !this.state.showConfirm;
    this.setState({showConfirm});
  }

  /**
   * exportQuote
   * submitQuote
   * local container callbacks which call redux actions
   */
  exportQuote = () => {
    const {quoteId} = this.props;
    const {exportQuote} = this.props.actions;

    exportQuote(quoteId);
  }

  submitQuote = () => {
    const {quoteId} = this.props;
    const {submitQuote} = this.props.actions;
    submitQuote(quoteId);
  }

  render() {

    const editActions = {
      handleOptionsEdit: this.handleOptionsEdit,
      handleLeaseEdit: this.handleLeaseEdit,
      handleDeliveryEdit: this.handleDeliveryEdit,
      toggleConfirm: this.toggleConfirm
    };

    const quoteActions = {
      exportAction: this.exportQuote,
      submitAction: this.submitQuote
    };

    return (
      <section>

        <SummaryConfirm

          onConfirm={this.handleVehicleChange}
          onCancel={this.toggleConfirm}
          isOpen={this.state.showConfirm}
        />
        <SummaryPage
          quoteActions={quoteActions}
          editActions={editActions}
          {...this.props}
          editable
        />

      </section>
    );
  }

}

QuoteSummary.propTypes = {
  notify: PropTypes.func,
  actions: PropTypes.object.isRequired,
  fetchingSummary: PropTypes.bool.isRequired,
  // summary card
  quoteId: PropTypes.string.isRequired,
  cost: PropTypes.number.isRequired,
  leaseTerms: PropTypes.string.isRequired,
  // full summary can be parsed by vehicle details panel
  selectedVehicle: PropTypes.object.isRequired,
  selectedColour: PropTypes.object.isRequired,
  // for listing included and optional extras
  includedExtras: PropTypes.array.isRequired,
  optionalExtras: PropTypes.array.isRequired,
  // array of lese details
  leaseDetails: PropTypes.array.isRequired,
  // obj for the delivery details panel
  deliveryDetails: PropTypes.object.isRequired,
  // bools for loading / disabled states on buttons
  isExporting: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  hasSubmitted: PropTypes.bool.isRequired
};

QuoteSummary.contextTypes = {
  router: PropTypes.object,
  store: PropTypes.object
};

const mapStateToProps = (state) => {

  const summary = getQuoteCreateFromattedSummary(state); 


  return {
    ...summary,
    // are we fetching and did it return anything?
    fetchingSummary: state.corporateQuote.create.fetchingSummary,

    // summary card
    quoteId: state.corporateQuote.create.quoteId,

    // bools for loading / disabled states on buttons
    isExporting: state.corporateQuote.create.exportingQuote,
    isSubmitting: state.corporateQuote.create.submittingQuote,
    hasSubmitted: state.corporateQuote.create.hasSubmitted

  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch),
  //notify: bindActionCreators(notify, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(QuoteSummary);



// WEBPACK FOOTER //
// ./src/features/corporate-quote/create/QuoteSummary.js